import React from "react";
import FooterMobile from "../../modules/Footer/FooterMobile";

export default function MainSecFiveMobile() {
  return (
    <div className="relative min-[769px]:hidden w-full h-screen flex items-center justify-center bg-color-primary-C">
      <FooterMobile />
    </div>
  );
}
